import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ExternalLink, FileText, Layout } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminSitePages() {
  const [data, setData] = useState({ static_pages: [], dynamic_pages: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/pages").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-pages-page">
      <header className="mb-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-champagne mb-2">Site map</p>
        <h1 className="font-serif text-3xl text-aubergine">All pages</h1>
        <p className="mt-2 text-sm text-aubergine/65">Static marketing pages and published articles.</p>
      </header>

      {loading ? <p className="text-aubergine/55 font-mono text-xs">Loading…</p> : (
        <div className="grid gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-aubergine/10 bg-white overflow-hidden">
            <div className="px-4 py-3 border-b border-aubergine/10 bg-bone/40 flex items-center gap-2">
              <Layout className="h-4 w-4 text-aubergine/55" />
              <p className="font-mono text-[11px] uppercase tracking-[0.12em] text-aubergine/65">Static pages</p>
              <span className="ml-auto text-[11px] text-aubergine/45">{data.static_pages.length}</span>
            </div>
            <ul className="divide-y divide-aubergine/10">
              {data.static_pages.map((p) => (
                <li key={p.path} className="px-4 py-3 flex items-center justify-between hover:bg-bone/40 transition-colors" data-testid={`static-page-${p.path}`}>
                  <div>
                    <div className="text-sm font-medium text-aubergine">{p.title}</div>
                    <div className="text-xs text-aubergine/55 font-mono">{p.path}</div>
                  </div>
                  <a href={p.path} target="_blank" rel="noreferrer" className="text-aubergine/55 hover:text-champagne"><ExternalLink className="h-3.5 w-3.5" /></a>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-aubergine/10 bg-white overflow-hidden">
            <div className="px-4 py-3 border-b border-aubergine/10 bg-bone/40 flex items-center gap-2">
              <FileText className="h-4 w-4 text-aubergine/55" />
              <p className="font-mono text-[11px] uppercase tracking-[0.12em] text-aubergine/65">Articles</p>
              <span className="ml-auto text-[11px] text-aubergine/45">{data.dynamic_pages.length}</span>
            </div>
            {data.dynamic_pages.length === 0 ? (
              <div className="p-6 text-sm text-aubergine/55">
                No articles yet. <Link to="/admin/articles/new" className="text-champagne hover:underline">Write the first one →</Link>
              </div>
            ) : (
              <ul className="divide-y divide-aubergine/10">
                {data.dynamic_pages.map((p) => (
                  <li key={p.path} className="px-4 py-3 flex items-center justify-between hover:bg-bone/40 transition-colors" data-testid={`dynamic-page-${p.path}`}>
                    <div>
                      <div className="text-sm font-medium text-aubergine">{p.title}</div>
                      <div className="text-xs text-aubergine/55 font-mono">{p.path}</div>
                    </div>
                    <div className="flex items-center gap-2">
                      {p.status === "published" ? (
                        <span className="inline-flex items-center gap-1.5 rounded-full bg-champagne/15 text-aubergine px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider"><span className="h-1.5 w-1.5 rounded-full bg-champagne" /> Live</span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 rounded-full bg-aubergine/10 text-aubergine/65 px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider"><span className="h-1.5 w-1.5 rounded-full bg-aubergine/40" /> Draft</span>
                      )}
                      {p.status === "published" && (
                        <a href={p.path} target="_blank" rel="noreferrer" className="text-aubergine/55 hover:text-champagne"><ExternalLink className="h-3.5 w-3.5" /></a>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
